import { Path } from "components/app.component";
import React, { useEffect, useState } from "react";
import {
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  confirmRental,
  RentalConfirmationInfoResponse,
} from "services/rentals-thin.service";
import {
  GlobalState,
  Rental,
  disableButton,
  isLoadingButton,
  enableButton,
  setNavigation,
  Payment as PaymentInterface,
  PaymentMethod,
  updateConfirmationDetails,
  store,
  updatePayment,
} from "store/rentals-store";
import { useSelector } from "react-redux";

export default function Payment() {
  const rental: Rental = useSelector((state: GlobalState) => state.rental);
  const path: string = useSelector(
    (state: GlobalState) => state.navigation.currentPath
  );
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
    rental.payment?.method
  );
  const navigation = useNavigate();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    async function submit(payment: PaymentInterface) {
      try {
        store.dispatch(isLoadingButton(true));
        setIsFormSubmitted(true);
        const response: RentalConfirmationInfoResponse = await confirmRental(
          payment
        );
        store.dispatch(
          updateConfirmationDetails({
            confirmationCode: response.data.confirmationCode,
          })
        );
        console.log("rental successfully created", response);
        navigation(Path.Confirmation);
        return;
      } catch (error) {
        console.error("there was an error creating rental");
        setNavigation(Path.Payment);
        navigation(Path.Payment);
        setIsFormSubmitted(false);
        store.dispatch(isLoadingButton(false));
        return;
      }
    }

    if (rental.payment?.method !== paymentMethod) {
      store.dispatch(updatePayment({ method: paymentMethod }));
      setNavigation(Path.Payment);
    }

    if (path === Path.Confirmation && !isFormSubmitted) {
      submit(rental.payment);
    }
  }, [rental, paymentMethod, path, isFormSubmitted]);

  useEffect(() => {
    paymentMethod
      ? store.dispatch(enableButton())
      : store.dispatch(disableButton());
  }, [paymentMethod]);

  return (
    <Container>
      <Typography
        fontSize={{
          lg: 35,
          md: 25,
          sm: 20,
          xs: 20,
        }}
      >
        Método de pago
      </Typography>
      <FormControl>
        <FormLabel id="payment-information">
          Selecciona el método de pago
        </FormLabel>
        <RadioGroup
          aria-labelledby="payment-information"
          value={paymentMethod}
          name="payment"
          onChange={(e) =>
            setPaymentMethod(e.currentTarget.value as PaymentMethod)
          }
        >
          <FormControlLabel
            value={PaymentMethod.CASH}
            control={<Radio />}
            label="Efectivo"
          />
          <FormControlLabel
            value={PaymentMethod.TRANSFER}
            control={<Radio />}
            label="Trasnferencia bancaria"
          />
        </RadioGroup>
        <Typography variant="caption" color="textSecondary">
          * El pago en efectivo se realizará al momento de recoger el vehículo.
          Para la transferencia bancaria, se proporcionarán los detalles de la
          cuenta después de confirmar la reserva.
        </Typography>
      </FormControl>

    </Container>
  );
}
